// extracted by mini-css-extract-plugin
module.exports = {"buttons-outer":"a10a3f92e9--buttons-outer--1_Zz1","complaint-outer":"a10a3f92e9--complaint-outer--3MBdV","tooltip":"a10a3f92e9--tooltip--3uQYt"};